<template>
  <div>
    <div>
    </div>
    <div class="selet-song-msg">
      <img src="@/assets/img/アセット 50@3x.png" />
    </div>
    <div>
    <ul :id="index" class="ul-style" v-for="(song, index) in soundList" :key="index">
      <li>
        <router-link to="/Selectedsong">
        <img class="sound-title" v-bind:src="song.titleImage" @click="selectedSong(song.id,song.assignment_img)"/>
        </router-link>
        <img
          class="btn-size"
          v-bind:src="song.playImage"
          v-if="isPlaySong === false"
          @click="playSound(song.sound,index)"
        />
        <img
          class="btn-size"
          v-bind:src="song.playImage"
          v-else
          @click="stopSound(index)"
        />
      </li>
    </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Selectsong",
  data() {
    return {
      isPlaySong: false,
      soundData: [],
      soundList: [],
    };
  },
  async mounted() {
    const res = await this.axios
      .get(process.env.API_ENDPOINT + "/songs", {
        headers: {
          Authorization:
            "Bearer " + this.$cookies.get('token'),
          "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
        },
      })
      .then((response) => (this.soundData = response.data))
      .catch((response) => console.log("エラーだよ", response));
    const songsCount = Object.keys(this.soundData);
    for (let i = 0; i < songsCount.length; i++) {
      if (this.soundData[i].id === 1) {
        this.soundList.push({
          id: 1,
          sound: this.soundData[i].sounds,
          titleImage: this.soundData[i].sounds_img.title_img,
          assignment_img: this.soundData[i].sounds_img.assignment_img,
          playImage: require("@/assets/img/アセット 53@3x.png"),
        });
      } else {
        this.soundList.push({
          id: 2,
          sound: this.soundData[i].sounds,
          titleImage: this.soundData[i].sounds_img.title_img,
          assignment_img: this.soundData[i].sounds_img.assignment_img,
          playImage: require("@/assets/img/アセット 53@3x.png"),
        });
      }
    }
  },
  methods: {
    playSound(sound,index) {
      this.soundList[index].playImage = require("@/assets/img/アセット 88@3x.png")
      this.audio = new Audio(sound);
      this.audio.play();
      this.isPlaySong = true;
      let self = this;
      this.audio.addEventListener(
        "ended",
        function () {
          self.soundList[index].playImage = require("@/assets/img/アセット 53@3x.png")
          self.isPlaySong = false;
        },
        false
      );
    },
    stopSound(index) {
      this.soundList[index].playImage = require("@/assets/img/アセット 53@3x.png")
      this.audio.pause();
      this.audio.currentTime = 0;
      this.isPlaySong = false;
    },
    allStopSound() {
      if(this.isPlaySong === true) {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.isPlaySong = false;
      }
    },
    selectedSong(songId, assignment_img) {
      this.allStopSound()
      this.$store.commit("SET_SELECTED_SONG", songId);
      this.$store.commit("SET_ASSIGNMENT_IMG", assignment_img)
    },
  },
};
</script>

<style>
.position-left {
  position: absolute;
  top: -40px;
  left: 10px;
}
.selet-song-msg {
  padding-top: 80px;
}
.selet-song-msg img {
  width: 500px;
}
.ul-style {
  list-style: none;
}
.btn-size {
  width: 180px;
}
.sound-title {
  width: 400px;
}
.teapicking-btn {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Selectsong.vue